import { manageTagActionTypes } from './../constants/ApiConstants';
const initialState = {
  master_data: [],
  loading: false,
  masterTagsList: null,
  masterTagDetails: null,
  saved_masterTag: null,
  deleted_masterTag: null,
};
export default (state = initialState, { type, payload }) => {
  switch (type) {
  case manageTagActionTypes.get_masterdata.REQUEST:
    return {
      ...state,
      loading: true,
    };
  case manageTagActionTypes.get_masterdata.SUCCESS:
    return {
      ...state,
      loading: false,
      master_data: payload,
    };
  case manageTagActionTypes.get_masterTagsList.REQUEST:
    return {
      ...state,
      loading: true,
      masterTagsList: null,
    };
  case manageTagActionTypes.get_masterTagsList.SUCCESS:
    return {
      ...state,
      loading: false,
      masterTagsList: payload,
    };
  case manageTagActionTypes.post_masterTag.REQUEST:
    return {
      ...state,
      loading: true,
      saved_masterTag: null,
    };
  case manageTagActionTypes.post_masterTag.SUCCESS:
    return {
      ...state,
      loading: false,
      saved_masterTag: payload,
    };
  case manageTagActionTypes.get_masterTagDetails.REQUEST:
    return {
      ...state,
      loading: true,
      masterTagDetails: null,
    };
  case manageTagActionTypes.get_masterTagDetails.SUCCESS:
    return {
      ...state,
      loading: false,
      masterTagDetails: payload,
    };
  case manageTagActionTypes.delete_masterTag.REQUEST:
    return {
      ...state,
      loading: true,
      deleted_masterTag: null,
    };
  case manageTagActionTypes.delete_masterTag.SUCCESS:
    return {
      ...state,
      loading: false,
      deleted_masterTag: payload,
    };
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/Masters/components/manageTags/reducers/ManageTagReducer.js